import { PageContainer } from '@/components/organisms'
import { Actions } from '@/containers/ClubPlus/Tabs/Overview/Actions'
import { TiersChart } from '@/containers/ClubPlus/Tabs/Overview/TiersChart/TiersChart'
import { TierList } from '@/containers/ClubPlus/Tabs/Overview/TierList/TierList'

export const OverviewTab = () => {
  return (
    <PageContainer data-testid="overview-tab" key="overview">
      <TiersChart />
      <TierList />
      <Actions />
    </PageContainer>
  )
}
